import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation";
import { Stage, Layer, Group, Rect, Image } from "react-konva";
import { useState, useEffect, useRef } from "react";
import Seat from '../../components/Seat/Seat';
import useActions from './acciones'
import useApi from "../../helpers/api";
import { useParams } from "react-router-dom";
import Loader from '../../components/Loader/Loader'

export default function Asientos() {
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [seatPositions, setSeatPositions] = useState([]);
  const [seatPositionsTemp, setSeatPositionsTemp] = useState(seatPositions);
  const [groupPosition, setGroupPosition] = useState({ x: 0, y: 0 });
  const [selectionBox, setSelectionBox] = useState(null);
  const [selectionStart, setSelectionStart] = useState(null);
  const [copiedSeats, setCopiedSeats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [history, setHistory] = useState([seatPositions]);
  const [historyIndex, setHistoryIndex] = useState(0);
  const url = process.env.REACT_APP_ENVIRONMENT === "local" ? `http://localhost:${process.env.REACT_APP_PORT}` : process.env.REACT_APP_API_URL;
  const { id } = useParams();
  const api = useApi();
  const stageRef = useRef(null);

  const { handleRightClick, handleRotateSeats,handleMouseUp, handleSelectSeat, handleCopy, handlePaste,
    handleDragMove, handleDragEnd, handleMouseDown, handleMouseMove, handleZoom, zoomIn, zoomOut,
    handleEdit, zoomReset, handleRotateCustom, handleRotateReset, handleMirrorSeats,
    handleMirrorSeatsVertically, handleRedo, handleUndo, handleAddMultipleSeats,
    handleRemoveSelectedSeats, handleReduceSeat, handleGrowSeat, handleSave, handleEditRow, handleEditColumn } = 
  useActions(
    selectedSeats, setSelectedSeats,
    seatPositions, setSeatPositions,
    seatPositionsTemp, setSeatPositionsTemp,
    groupPosition, setGroupPosition,
    selectionBox, setSelectionBox,
    selectionStart, setSelectionStart,
    copiedSeats, setCopiedSeats,
    stageRef, history, setHistory,
    historyIndex, setHistoryIndex,
    backgroundImage, id, setLoading
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "c") {
        handleCopy();
      } else if (e.ctrlKey && e.key === "v") {
        handlePaste();
      } else if (e.key === "r") {
        handleRotateSeats();
      } else if (e.key === "e") {
        handleEdit();
      } else if (e.key === "h") {
        handleMirrorSeats();
      } else if (e.key === "v") {
        handleMirrorSeatsVertically();
      } else if (e.ctrlKey && e.key === "z") {
        handleUndo();
      } else if (e.ctrlKey && e.shiftKey && (e.key === "z" || e.key === "Z")) {
        handleRedo();
      } else if (e.key === "Delete") {
        handleRemoveSelectedSeats();
      } else if (e.key === "+") {
        handleGrowSeat();
      } else if (e.key === "-") {
        handleReduceSeat();
      } else if (e.key === "f") {
        handleEditRow();
      } else if (e.key === "c") {
        handleEditColumn();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleKeyDown, { passive: false });
    return () => {window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleKeyDown);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSeats, copiedSeats, seatPositions]);

  useEffect(() => {
    async function getSala () {
      const sala = await api.getSala(id);
      if(!sala.message){
        const asientos = await api.getAsientosBySala(sala.id);
        setSeatPositions(asientos)
        setSeatPositionsTemp(asientos)
      }
      const image = new window.Image();
      image.src = url+sala.layout;
      image.onload = () => setBackgroundImage(image);
    }
    getSala()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
    {/* {console.log(seatPositions.length)} */}
    {/* {console.log(selectedSeats)} */}
      <Navigation />
      <SecondaryNavigation title="Asientos" />
      <div className="d-flex justify-content-around">
        <div className="ms-4 mt-3">
          <div className="d-flex flex-wrap justify-content-center" style={{width:'80vw'}}>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={()=>handleRotateSeats(45)}>Rotate 45°</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleRotateCustom}>Rotate Custom °</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={()=>handleRotateSeats(10)}>+10°</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={()=>handleRotateSeats(-10)}>-10°</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleRotateReset}>Reset rotation</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleCopy}>Copy</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handlePaste}>Paste</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={zoomIn}>Zoom In</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={zoomOut}>Zoom Out</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={zoomReset}>Reset Zoom</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleEdit}>Edit Number</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleEditRow}>Edit Row</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleEditColumn}>Edit Column</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleGrowSeat}>Grow Seat</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleReduceSeat}>Reduce Seat</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleMirrorSeats}>Mirror H</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleMirrorSeatsVertically}>Mirror V</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleRedo} disabled={historyIndex === history.length - 1}>Redo</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleUndo} disabled={historyIndex === 0}>Undo</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={() => handleAddMultipleSeats("seat")}>➕➕ Add Seats (Max 20)</button>
            <button className="btn btn-outline-grey me-2 mb-2" onClick={handleRemoveSelectedSeats} disabled={selectedSeats.length === 0}>🗑 Remove Selected</button>
          </div>
        </div>
        <div className="mt-3 d-flex justify-content-center">
          <button className="btn btn-primary me-2 mb-2" onClick={()=>handleSave(api)}>{loading ? <Loader/> : 'Guardar'}</button>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <Stage 
          width={backgroundImage?.width ? backgroundImage.width : window.innerWidth}
          height={backgroundImage?.height ? backgroundImage.height : window.innerHeight}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onContextMenu={handleRightClick}
          onWheel={handleZoom}
          ref={stageRef}
          className="p-5"
        >
          <Layer>
            {backgroundImage && (
              <Image
                image={backgroundImage}                
                width={backgroundImage.width}
                height={backgroundImage.height}
                listening={false}
              />
            )}
            {seatPositions.map((pos) => (
              selectedSeats.includes(pos.id) ?
                null :
                <Seat
                  {...pos}
                  key={pos.id}
                  id={pos.id}
                  x={pos.x}
                  y={pos.y}
                  row={pos.row}
                  column={pos.column}
                  rotation={pos.rotation}
                  number={pos.numero}
                  isSelected={selectedSeats.includes(pos.id)}
                  onSelect={()=>handleSelectSeat(pos.id)}
                />
              )
            )}

            {selectedSeats.length > 0 && (
              <Group
                x={groupPosition.x}
                y={groupPosition.y}
                draggable
                onDragMove={handleDragMove}
                onDragEnd={handleDragEnd}
              >
                {seatPositions.map((pos) =>
                  selectedSeats.includes(pos.id) ? (
                    <Seat
                      {...pos}
                      key={pos.id}
                      id={pos.id}
                      x={pos.x}
                      y={pos.y}
                      row={pos.row}
                      column={pos.column}
                      rotation={pos.rotation}
                      number={pos.numero}
                      isSelected={true}
                      onSelect={()=>handleSelectSeat(pos.id)}
                    />
                  ) : null
                )}
              </Group>
            )}
            {selectionBox && (
              <Rect
                x={selectionBox.x}
                y={selectionBox.y}
                width={selectionBox.width}
                height={selectionBox.height}
                stroke="blue"
                strokeWidth={1}
                fill="rgba(0,0,255,0.1)"
              />
            )}
          </Layer>
        </Stage>
      </div>
    </>
  );
}
